import { getUpdatedSelectionOnRowSelected } from 'components/AbstractAgGridCustomHeader/helpers/selection'

export const makeOnOutputRowSelected =
  (outputStore, selectionSelector, updateSelectionState) =>
  ({ node }) => {
    outputStore.update((prevState) => {
      const selection = outputStore.get(selectionSelector)
      const newSelection = getUpdatedSelectionOnRowSelected(selection, node)
      return updateSelectionState(newSelection, prevState)
    })
  }
